import { useEffect } from 'react';
import { useAuthStore, useManualLocationStore, useSystemToolsStore } from '../../stores';
import { ManualLocationFab } from './ManualLocationFab';
import { RoleSwitcherFab } from './RoleSwitcherFab';

export function SystemToolsFabs() {
    const userId = useAuthStore((state) => state.user?.id ?? null);
    const settings = useSystemToolsStore((state) => state.settings);
    const load = useSystemToolsStore((state) => state.load);

    useEffect(() => {
        if (userId !== null) {
            void load();
        }
    }, [load, userId]);

    useEffect(() => {
        if (settings && !settings.manual_location_enabled) {
            useManualLocationStore.getState().reset();
        }
    }, [settings]);

    if (!settings || userId === null) {
        return null;
    }

    return (
        <>
            <RoleSwitcherFab enabled={settings.role_switcher_enabled} />
            <ManualLocationFab enabled={settings.manual_location_enabled} />
        </>
    );
}
